import styled from '../../../../../../utils/styling/styled';

import styleUtils from '../../../../../../utils/styling/styleUtils';

export const List = styled.ul`
  ${styleUtils.media.orientation.landscape} {
    width: 80%;
  }
`;
